module.exports = __webpack_public_path__ + "static/ogp-aabc4144bfc7cb81554897ddd8ff61b2.png";